import { IconName } from '@outlaw/icons';

export const POST_TYPE_ICON: Record<string, IconName> = {
  post: 'postBubble',
  followed_channel: 'plusInCircle',
  followed_user: 'plusInCircle',
  youtube: 'postBubble',
  liked: 'recommendFilled',
  repost: 'recommendFilled',
  liked_video: 'recommendFilled',
  liked_playlist: 'recommendFilled',
  spotify: 'heartFilled',
  instagram: 'heartFilled',
  soundcloud: 'postBubble',
  posted_video: 'playVideo',
};
